import script from "./SearchCategoryInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchCategoryInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchCategoryInput.vue?vue&type=style&index=0&id=625a31bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-625a31bf"]])

export default __exports__